import {Route} from "@angular/router";
import {InterventionTeamsNavigationComponent} from "./navigation/intervention-teams-navigation.component";
import {InterventionTeamManagerComponent} from "./teams/intervention-team-manager/intervention-team-manager.component";
import {ContactsManagerComponent} from "./contacts/contacts-manager/contacts-manager.component";
import {InterventionTeamEditorComponent} from './teams/intervention-team-editor/intervention-team-editor.component';

export const routes: Route[] = [
  {
    path: 'intervention-teams',
    component: InterventionTeamsNavigationComponent,
    children: [
      {
        path: 'teams', component: InterventionTeamManagerComponent,
        children: [
          { path: ':id', component: InterventionTeamEditorComponent }
        ]
      },
      {path: 'contacts/:id', component: ContactsManagerComponent},
      {path: 'contacts', component: ContactsManagerComponent},
    ]
  }

];
